import { HotKeys } from 'react-hotkeys'
import OutsideClickHandler from 'react-outside-click-handler'

import { Box, dimensions } from '@factorialco/deprecated-design-system'

import TetherComponent from 'modules/core/components/TetherComponent'
import { Attachment } from 'modules/core/components/TetherComponent/types'

type Props = React.PropsWithChildren<{
  trigger: React.ReactNode
  open: boolean
  onClose: () => void
  attachment?: Attachment
  targetAttachment?: Attachment
}>

export interface PopoverPosition {
  attachment: Attachment
  targetAttachment: Attachment
}

export const POPOVER_POSITION: PopoverPosition = {
  attachment: 'top center',
  targetAttachment: 'bottom center',
}

export const Popover = ({
  trigger,
  open,
  onClose,
  children,
  attachment,
  targetAttachment,
}: Props) => {
  return (
    <TetherComponent
      attachment={attachment ?? POPOVER_POSITION.attachment}
      targetAttachment={targetAttachment ?? POPOVER_POSITION.targetAttachment}
      offset={`-${dimensions.s8} 0`}
      type="popover"
    >
      {trigger}
      {open && (
        <OutsideClickHandler onOutsideClick={onClose} useCapture={false}>
          <HotKeys
            keyMap={{
              keyEscape: 'escape',
            }}
            handlers={{
              keyEscape: onClose,
            }}
          >
            <Box
              borderRadius={{ all: 'abs008' }}
              border={{
                all: {
                  width: 's1',
                  color: 'darker080',
                  style: 'solid',
                },
              }}
              boxShadow="s300"
              background="grey000White"
            >
              {children}
            </Box>
          </HotKeys>
        </OutsideClickHandler>
      )}
    </TetherComponent>
  )
}
